import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-access-type-help-modal',
  templateUrl: './access-type-help-modal.component.html',
  styleUrl: './access-type-help-modal.component.scss',
})
export class AccessTypeHelpModalComponent {
  copied = false;

  autoAssignmentDescription = [
    {
      title: 'Access Control:',
      items: [
        'All users with access to the forms module can use this form',
        'No role restrictions or permission grants required',
        'Available to all users in the system with forms module access',
      ],
    },
    {
      title: 'Limitations:',
      items: [
        'Once submitted, users can fill out a new entry',
        'Only one entry at a time is allowed per user',
      ],
    },
  ];

  limitedRoleDescription = [
    {
      title: 'Access Requirements:',
      items: [
        'Users must have access to the forms module',
        'Users must have the role specified in settings.limitations',
        'Each role has a limit on how many times they can start and complete the form',
      ],
    },
    {
      title: 'Date Controls:',
      items: [
        'start_date: When the form becomes available for users to start entries',
        'lockdown: When entries are closed - all started forms cannot be completed and no new entries can be started, even if your role would normally allow more (hard closure)',
      ],
    },
  ];

  standaloneDescription = [
    {
      title: 'Access Control:',
      items: [
        'Only users who have been previously granted permissions can access this form',
        'A user with the <span class="px-1.5 py-0.5 text-xs font-semibold text-purple-700 bg-purple-100 dark:bg-purple-900/30 dark:text-purple-400 rounded">PAVCON</span> role must grant permissions to specific users',
        'Permissions are managed in the User Permissions module',
      ],
    },
    {
      title: 'Entry Limitations:',
      items: [
        'Only one entry at a time is allowed per user',
        'Users must complete or discard the previous entry before starting a new one',
        'This ensures focused completion of each form entry',
      ],
    },
  ];

  requestAccessDescription =
    'For authorized <span class="px-1.5 py-0.5 text-xs font-semibold text-purple-700 bg-purple-100 dark:bg-purple-900/30 dark:text-purple-400 rounded">PavCon</span> users only.';

  constructor(
    public dialogRef: MatDialogRef<AccessTypeHelpModalComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: {
      accessTypes: Array<{
        label: string;
        value: string;
        description: string;
      }>;
      limitationsExample?: string;
    }
  ) {}

  onClose(): void {
    this.dialogRef.close();
  }

  async copyToClipboard(): Promise<void> {
    if (!this.data.limitationsExample) {
      return;
    }

    try {
      await navigator.clipboard.writeText(this.data.limitationsExample);
      this.copied = true;
      setTimeout(() => {
        this.copied = false;
      }, 2000);
    } catch (err) {
      console.error('Failed to copy text: ', err);
    }
  }
}
